import { render, staticRenderFns } from "./project-information.vue?vue&type=template&id=b2b3c2da&"
import script from "./project-information.vue?vue&type=script&lang=ts&"
export * from "./project-information.vue?vue&type=script&lang=ts&"
import style0 from "./project-information.vue?vue&type=style&index=0&id=b2b3c2da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports